module.exports = __webpack_public_path__ + "img/BGJrPanel3.b5da47d.webp";